export default "__VITE_ASSET__Cgv1SEHb__"